module.exports = __webpack_public_path__ + "img/contextual_token.a2203b25.svg";